import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../../const/endpoints';
var mutationFnFactory = function (config, keyProps) {
    var fetchWrapper = getFetchWrapper(config);
    return function (_a) {
        var newDueDay = _a.newDueDay, sendLetter = _a.sendLetter;
        var requestPayload = {
            'cipher.accountId': keyProps.accountId,
            accountIdType: keyProps.accountIdType,
            newDueDay: newDueDay,
            sendLetter: sendLetter
        };
        return fetchWrapper(ENDPOINTS.changePaymentDueDate, {
            method: 'PUT',
            body: JSON.stringify(requestPayload)
        });
    };
};
export default mutationFnFactory;
